export default __webpack_public_path__ + "static/media/budget.ab08c559.svg";